import './footer.scss';

import React from 'react';
import { Translate } from 'react-jhipster';
import { Col, Row } from 'reactstrap';

const Footer = props => (
  <div className="footer page-content">
    <Row>
      <Col md="12" className='flex flex-col text-center' >
       
          <p>Copyright @ 2023
            <br />
            FitEngineer | Yuraj Jadhav  <br />
            InnovITek Solutions
          </p>
       
      </Col>
    </Row>
  </div>
);

export default Footer;
